import { defineStore } from 'pinia'

import type { DisciplineStageLogsStore } from './interfaces'

import { actions } from './actions'
import { getters } from './getters'

export const useDisciplineStageLogsStore = defineStore('discipline-stage-logs', {
  state: (): DisciplineStageLogsStore => ({
    loading: false,
    logs: [],
    nextCursor: null,
  }),
  actions,
  getters,
})
